import Vue from 'vue';
import VueRouter from 'vue-router';
import Game from '../views/pay/game';
import Index from '../views/pay/index';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/game',
    name: 'game',
    component: () => import('../views/pay/game')
  },
  // {
  //   path: '/pay',
  //   name: 'pay',
  //   component: () => import('../views/pay/index')
  // },
  {
    path: '/prod',
    name: 'prod',
    component: () => import('../views/pay/prod')
  },
  {
    path: '/submit',
    name: 'submit',
    component: () => import('../views/pay/submit')
  },
  {
    path: '/payResult',
    name: 'payResult',
    component: () => import('../views/pay/payResult')
  },
  {
    path: '/index_1',
    name: 'index_1',
    component: () => import('../views/pay/index_1')
  },
  {
    path: '/pcIndex',
    name: 'pcIndex',
    component: () => import('../views/pay/pcIndex')
  },
  {
    path: '/pcSubmit',
    name: 'pcSubmit',
    component: () => import('../views/pay/pcSubmit')
  },
  {
    path: '/pcpay',
    name: 'pcpay',
    component: () => import('../views/pay/pcpay')
  },
  {
    path: '/pcrole',
    name: 'pcrole',
    component: () => import('../views/pay/pcrole')
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;
